import { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { urlManager } from 'services/api/config';
import { useGetPageTitle } from 'services/helpers/seo';
import { Nullable } from 'types';

const HeadMetaData = ({
  title,
  contentDescription,
}: {
  title?: Nullable<string>;
  contentDescription?: Nullable<string>;
}): ReactElement => {
  const location = useLocation();
  const { isNoIndex } = useGetPageTitle();
  const renderTitle = () => {
    if (!title) return null;
    return <title>{title}</title>;
  };

  const renderDescription = () => {
    if (!contentDescription) return null;
    return <meta name="description" content={contentDescription} />;
  };

  const renderMetaRobots = () => {
    if (isNoIndex) {
      return <meta name="robots" content="noindex" />;
    }
    return null;
  };

  const renderCanonicalUrl = () => {
    const { homepage } = urlManager;
    const { origin } = window.location;
    let { pathname } = location;
    // if pathname is ending with "/" then remove it
    // homepage is exception for this rule
    if (pathname.match(/\/$/) && pathname !== '/')
      pathname = pathname.slice(0, -1);
    const canonicalUrl = `${origin}${homepage}${pathname}`;
    return <link rel="canonical" href={canonicalUrl} />;
  };

  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        {renderTitle()}
        {renderDescription()}
        {renderCanonicalUrl()}
        {renderMetaRobots()}
      </Helmet>
    </>
  );
};

HeadMetaData.defaultProps = {
  title: null,
  contentDescription: null,
};

export default HeadMetaData;
